import React, { useContext, useEffect, useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../../components/MaterialDataGrid'
import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from '@mui/material'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialBox from '../../../components/MaterialBox'
import { useUserDetails } from '../../../context/auth'
import { getExitFormData, getExitFormDataMyList, getExitFormDataTeamList } from './GraphQl'
import BASEURL from '../../Utils/Baseurl'
import request from 'graphql-request'
import { useNavigate } from 'react-router-dom'
import { DesignationContext } from '../../../context/designationcontext'

const ExitFormList = () => {
    let MainValue;
    const userData = JSON.parse(sessionStorage.getItem("user"));
    const myId = userData.id;
    const { setDesignation } = useContext(DesignationContext);
    const tablist = JSON.parse(sessionStorage.getItem("exitTab"));
    const [value, setValue] = useState(MainValue || "Employee");
    const { AccessData } = useUserDetails();
    const navigate = useNavigate();
    const[tableData, setTableData] = useState([]);
    if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) => item.component === "HrApproval" && item.can_access
        )
      ) {
        if (tablist === "HR List") {
          MainValue = "HR List";
        } else if (tablist === "Team List") {
          MainValue = "Team List";
        } else {
          MainValue = "Employee";
        }
      }
    
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) => item.component === "ManagerApproval" && item.can_access
        )
      ) {
        if (tablist === "Team List") {
          MainValue = "Team List";
        } else {
          MainValue = "Employee";
        }
      }
    
      if (
        AccessData &&
        Array.isArray(AccessData) &&
        !AccessData.some(
          (item) =>
            item.component === "ManagerApproval" || item.component === "HrApproval"
        )
      ) {
        MainValue = "Employee";
    }

    useEffect(() => {
      const tabName = JSON.parse(sessionStorage.getItem("exitTab"));

if(tabName){
  setValue(tabName);
}else{
  setValue("Employee");
}
    }, [])
    

    //Fetch Table Data
      useEffect(() => {
        if(value == "Employee"){
          const fetchEmployeeList = async () => {
            try{
              const response = await request(BASEURL, getExitFormDataMyList,{
                userid: myId,
              })
              const data = response.allExitInterviewsUser;
              setTableData(data);
              console.log("12333",data);
              
            }
            catch(error){
              console.error("Error fetching Data ",error);
            }
          };
          fetchEmployeeList();
        }
    
        if(value == "Team List"){
          const fetchTeamList = async () => {
            try{
              const response = await request(BASEURL, getExitFormDataTeamList,{
                id: myId,
              })
     
              const data = response?.exitInterviewTeam?.data;
              console.log("teamlist",data);
              setTableData(data);
            }
            catch(error){
              console.error("Couldn't fetch Data: ",error);
            }
          }
          fetchTeamList();
        }
        
        if(value == "HR List"){
          const fetchResignationData = async () => {
            try{
              const response = await request(BASEURL, getExitFormData)
              console.log("dasa",response?.allExitInterviews);
              const data=response?.allExitInterviews;
              setTableData(data);
            }
            catch(error){
              console.error("Error fetching Data",error)
            }
          };
          fetchResignationData();
        }
      }, [value]);

    //Table Mapping
    const dataListTable = {
        columns: [
          {
            headerName: "S.No",
            field: "sno",
            name: "S No",
            width: 1,
            disableColumnMenu: true,
            editable: false,
          },
          {
            headerName: "Emp ID",
            field: "empid",
            name: "empid",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "Name",
            field: "name",
            name: "name",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "Department",
            field: "department",
            name: "department",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "Designation",
            field: "designation",
            name: "designation",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "Exit Reason",
            field: "exitReason",
            name: "exitReason",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "New Job Reason",
            field: "newJobReason",
            name: "newJobReason",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
          {
            headerName: "Additional Benefits",
            field: "additionalBenefits",
            name: "additionalBenefits",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
        
          {
            headerName: "Created At",
            field: "createdAt",
            name: "Created At",
            flex: 1,
            editable: false,
            disableColumnMenu: true,
          },
        ],
        rows: tableData.reverse().map((val, index) => ({
          sno: index + 1,
          id: val.id,
          empid: val.user.empid,
          name: val.user.firstName + " " +val.user.lastName,
          department: val.user.department,
          designation: val.user.designation,
          additionalBenefits: val.additionalBenefits === "Other" ?
          val.additionalBenefitsComments : val.additionalBenefits ,
          exitReason: val.exitReason === "Other" ? val.othersExitReason : val.exitReason,
          newJobReason: val.newJobReason === "Other" ? val.othersNewJobReason : val.newJobReason,
          createdAt: val.createdAt.slice(0,10),

        })),
    }; 

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue == "HR List") {
          sessionStorage.setItem("exitTab", JSON.stringify(newValue));
        } else if (newValue == "Manager") {
        } else if (newValue == "Team List") {
          sessionStorage.setItem("exitTab", JSON.stringify(newValue));
        } else if (newValue == "ManagerList") {
          sessionStorage.setItem("exitTab", JSON.stringify(newValue));
        } else if (newValue == "Employee") {
          sessionStorage.setItem("exitTab", JSON.stringify(newValue));
        }
    };

    //Row Click Navigation
    const onRowClick = (e) => {
        console.log(e, "event");
    
        if (!e?.id) return;           
    
        setDesignation({ value });
        navigate(`/exit-form/add-exit-form?id=${e.id}`);
      };

  return (
    <DashboardLayout>
           <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Exit Form List
                </MaterialTypography>
              </Stack>
              <MaterialBox alignItems="center" width="60%">
                  <MaterialBox width="80%">
                      <div style={{ position: "relative", left: "20px" }}>
                          <AppBar position="static">
                              <Tabs
                               orientation={"horizontal"}
                               value={value}
                               onChange={handleChange}
                               sx={{ backgroundColor: "transparent" }}>
                                  {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "HrApproval" &&
                                item.can_access
                            ) && <Tab label="HR List" value="HR List" />}
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "HrApproval" &&
                                item.can_access
                            ) && <Tab label="Team List" value="Team List" />}

                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "ManagerApproval" &&
                                item.can_access
                            ) && <Tab label="Team List" value="Team List" />}

                          <Tab label="My List" value="Employee" />
                              </Tabs>
                          </AppBar>
                      </div>
                  </MaterialBox>
              </MaterialBox>
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={500}
          rows={dataListTable.rows}
          columns={dataListTable.columns}
          isSelectable={false}
          // onRowClick={(tablist == "Employee" && onDataListClick)
          //   || onOthersListClick
          // }
          onRowClick={onRowClick}
          checkboxSelection={false}
        //   loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Exit form found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any designation details. Click on the
                  "Add resignation" module to start adding designation details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  )
}

export default ExitFormList